import { operations, paths } from "./generated-types";
import createClient from "openapi-fetch";
import {
  requestIdMiddleware,
  sessionTokenMiddleware,
} from "@wiesinghilker/extension-lib-frontend";

const client = createClient<paths>({
  baseUrl: import.meta.env.VITE_APP_API_BASE_URI,
  credentials: "include",
});

client.use(sessionTokenMiddleware);
client.use(requestIdMiddleware);

// same as regular client, but without session token middleware
const publicClient = createClient<paths>({
  baseUrl: import.meta.env.VITE_APP_API_BASE_URI,
  credentials: "include",
});

publicClient.use(requestIdMiddleware);

export const getSesseion = (
  params: operations["getSSHSession"]["parameters"],
) => {
  return publicClient.GET("/ssh/sessions/{sessionId}", {
    params,
    signal: AbortSignal.timeout(2000),
  });
};

export const createSession = (
  body: operations["connectSSH"]["requestBody"]["content"]["application/json"],
  params: operations["connectSSH"]["parameters"],
) => {
  return client.POST("/ssh/connect", {
    body,
    params,
    // Backend now establishes the SSH handshake eagerly: up to
    // 2 attempts × 45s readyTimeout plus retry backoff (~95s worst case).
    signal: AbortSignal.timeout(100000),
  });
};

export const getVariantStatus = (
  params: operations["getVariantStatus"]["parameters"],
) => {
  return client.GET("/variant-status", {
    params,
    signal: AbortSignal.timeout(5000),
  });
};

export const changeVariantProject = (
  body: operations["changeVariantProject"]["requestBody"]["content"]["application/json"],
) => {
  return client.POST("/variant/change-project", {
    body,
    signal: AbortSignal.timeout(10000),
  });
};
